(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Free-gifts-custom"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  /* ── Dynamic date ── */
  const setDynamicDate = () => {
    const orderBy = document.querySelector('.save56-order-by');
    if (!orderBy) return;

    const preOrderDays = parseInt(orderBy.dataset.preorderDays, 10) || 0;
    const dynamicDate  = orderBy.querySelector('.dynamic--date');
    if (!dynamicDate) return;

    const d = new Date();
    d.setDate(d.getDate() + preOrderDays);
    dynamicDate.textContent = d.toLocaleDateString(undefined, { month: 'long', day: '2-digit' });
  };

  /* ── Gift slider ── */
  const initGiftSlider = () => {
    const wrapper = document.querySelector('.gift-blocks-wrapper');
    if (!wrapper) return;

    const giftsCount          = parseInt(wrapper.dataset.giftsCount, 10);
    const sliderEnabledDesktop = wrapper.dataset.sliderEnabledDesktop === 'true';
    const sliderEnabledMobile  = wrapper.dataset.sliderEnabledMobile  === 'true';

    const giftBlocks = wrapper.querySelector('.save56-gift-blocks');
    const prevArrow  = wrapper.querySelector('.gift-slider-prev');
    const nextArrow  = wrapper.querySelector('.gift-slider-next');
    if (!giftBlocks || !prevArrow || !nextArrow) return;

    giftBlocks.classList.remove('slider-enabled-desktop', 'slider-enabled-mobile');
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';

    if (giftsCount <= 4) return;

    const isMobile         = window.innerWidth <= 768;
    const shouldEnable     = isMobile ? sliderEnabledMobile : sliderEnabledDesktop;
    if (!shouldEnable) return;

    giftBlocks.classList.add(isMobile ? 'slider-enabled-mobile' : 'slider-enabled-desktop');

    const getScrollAmount = () => {
      const item = giftBlocks.querySelector('.free-gift-item--product');
      if (!item) return 200;
      return item.offsetWidth + parseInt(getComputedStyle(giftBlocks).columnGap || 4, 10);
    };

    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = giftBlocks;
      prevArrow.style.display = scrollLeft <= 5 ? 'none' : 'flex';
      nextArrow.style.display = scrollLeft + clientWidth >= scrollWidth - 5 ? 'none' : 'flex';
    };

    prevArrow.addEventListener('click', () => {
      giftBlocks.scrollTo({ left: Math.max(0, giftBlocks.scrollLeft - getScrollAmount()), behavior: 'smooth' });
    });

    nextArrow.addEventListener('click', () => {
      const max = giftBlocks.scrollWidth - giftBlocks.clientWidth;
      giftBlocks.scrollTo({ left: Math.min(max, giftBlocks.scrollLeft + getScrollAmount()), behavior: 'smooth' });
    });

    giftBlocks.addEventListener('scroll', updateArrows);
    updateArrows();
  };

  /* ── Bootstrap ── */
  const init = () => { setDynamicDate(); initGiftSlider(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initGiftSlider, 250);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
